import classNames from "classnames";

import {timeStringWithTimezone} from "@/components/datetime/utils.ts";
import {TimeFormatName} from "@/lib/types/common.ts";

type ShortTimeUserProps = {
  date: Date;
  timezone?: string;
  timeFormat?: TimeFormatName;
  className?: classNames.ArgumentArray | string;
  bottomClassName?: classNames.ArgumentArray | string;
};

export const ShortTimeUser = ({date, timezone, timeFormat, className}: ShortTimeUserProps) => {
  return <div className={classNames(className)}>{timeStringWithTimezone(date, timezone, timeFormat)}</div>;
};
